import {
  ContactPreferenceCategory,
  ContactPreferenceChannel,
  getServerKeyForContactPreferenceCategory,
} from '../../utils/contact-preferences.ts';

export {
  ContactPreferenceCategory,
  ContactPreferenceChannel,
  contactPreferenceChannels,
} from '../../utils/contact-preferences.ts';

export const contactPreferenceCategoryCodes: Record<
  ContactPreferenceCategory,
  string
> = Object.fromEntries(
  Object.values(ContactPreferenceCategory).map((category) => [
    category,
    getServerKeyForContactPreferenceCategory(category),
  ]),
) as Record<ContactPreferenceCategory, string>;

export type ContactPreferencesState = Record<
  string,
  ContactPreferenceChannel[]
>;

export type ContactPreferencesFormValues = Record<
  string,
  Partial<Record<ContactPreferenceChannel, boolean | undefined>> | undefined
>;

export type OptOutChannels = ReadonlySet<ContactPreferenceChannel>;
